<template>
  <div class="c-base-timer">
    <svg class="c-base-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <g class="c-base-timer__circle">
        <circle class="c-base-timer__path-elapsed" cx="50" cy="50" r="45"></circle>
        <path :stroke-dasharray="strokeDashArray" class="c-base-timer__path-remaining" d=" M 50, 50 m -45, 0 a 45,45 0 1,0 90,0 a 45,45 0 1,0 -90,0 " />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'BaseTimer',

  props: {
    initialTime: {
      required: true,
      type: Number
    }
  },

  data () {
    return {
      timePassed: 0,
      timerInterval: null
    }
  },

  mounted () {
    this.timerInterval = setInterval(() => (this.timePassed += 1), 1000)

    this.$watch(() => this.timeLeft, timeLeft => {
      if (timeLeft === 0) {
        clearInterval(this.timerInterval)
      }
    })
  },

  beforeDestroy () {
    clearInterval(this.timerInterval)
  },

  computed: {
    strokeDashArray () {
      const rawTimeFraction = this.timeLeft / this.initialTime

      return `${((rawTimeFraction - (1 / this.initialTime) * (1 - rawTimeFraction)) * 283).toFixed(0)} 283`
    },

    timeLeft () {
      return this.initialTime - this.timePassed
    }
  }
}
</script>
